export function handleResponse(resposta) {
  if (resposta.status === 200) {
    return resposta.data;
  } else {
    return null;
  };
};

export function handleError(err) {
  console.error(err);
  throw err;
};
